export enum UserStatuses {
  "ACTIVE" = "ACTIVE",
  "INACTIVE" = "INACTIVE",
  "DELETED" = "DELETED",
}
